'use strict';
import { tns } from "tiny-slider/src/tiny-slider"

class Stats {

    constructor($target) {

        //Private properties
        $target;
        
        let name = "HELLO";

        function init(){
            initSlider();
            addEventListeners();
           
        }

        function addEventListeners(){
            //$(window).resize(initSlider);   
        }

        function initSlider(){

            var block_name = $target.find('.block_stats__content_container')[0];


            // forEach function
            var forEach = function (array, callback, scope) {
                for (var i = 0; i < array.length; i++) {
                    callback.call(scope, i, array[i]); // passes back stuff we need
                    console.log(array.length)
                }
            }
           

            // select all slider parent div.tartist-tiny-slider
            var sliders = document.querySelectorAll('.block_stats__content_container__'+block_name.title);

            // chunk function to make groups for every slider's childrens
            var chunk = function ( array, size ) {
                let arr = [];
                for ( let i = 0; i < array.length; i += size ) {
                    let newSlicedArray = Array.prototype.slice.call( array, i, i + size );
                    arr.push(newSlicedArray);
                }
                return arr;
            }
            

            // applying foreach function to the sliders
            forEach(sliders, function (index, value) {

                //selecting childrens
                let childrens = value.querySelectorAll(".block_stats__content");

                //getting chunksize from the parent
                
                

                function getSliderArray(){
            
                    if($(window).width() <= 599){
                        $(".block_stats__content_container").attr('data-chunksize', 2);
                        // $(".block_stats__content_container .block_stats__wrap").css('grid-template-columns','repeat(1, 1fr)');
                    } else if($(window).width() <= 991){
                        $(".block_stats__content_container").attr('data-chunksize', 4);
                        // $(".block_stats__content_container .block_stats__wrap").css('grid-template-columns','repeat(2, 1fr)');
                    }
                    else{
                        $(".block_stats__content_container").attr('data-chunksize', 6);
                        // $(".block_stats__content_container .block_stats__wrap").css('grid-template-columns','repeat(3, 1fr)');
                    }

                }
                getSliderArray();

                $(window).resize(getSliderArray);

                let chunkSize = value.dataset.chunksize;

                //making final arrays for the children with chunk size
                let final = chunk( childrens, parseInt(chunkSize) );

                //wrapping the chunks with div.wrap
                let newHTML = final.map( towrap => towrap.reduce( (acc, el) => (acc.appendChild(el),acc) , document.createElement('div') ) ).forEach( el => {
                    el.className ="block_stats__wrap";
                    value.appendChild(el)
                })

                //initialize tiny slider    
                let slider = tns({
                    container: value,
                    items: 1,
                    slideBy: "page",
                    autoplayButtonOutput: false,
                    loop: true,
                    mouseDrag: true,
                    gutter: 20,
                    controls: false,
                    navPosition: "bottom",
                    nav: true,
                });

            });
        }
        
        init()
        return {

            //Public properties
            name:name,

            publicBlockHero:function(string){

                // $target.append("HELLO!"+string);
                // console.log(name)
                // console.log(string)
                // console.log($target)

            }

        }

    }

}

export default Stats;
